import { render, staticRenderFns } from "./ResiduesByTechnologyPizzaGraph.vue?vue&type=template&id=c8093640&scoped=true"
import script from "./ResiduesByTechnologyPizzaGraph.vue?vue&type=script&lang=js"
export * from "./ResiduesByTechnologyPizzaGraph.vue?vue&type=script&lang=js"
import style0 from "./ResiduesByTechnologyPizzaGraph.vue?vue&type=style&index=0&id=c8093640&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8093640",
  null
  
)

export default component.exports